import { i18nMark } from 'lingui-react';

/* eslint-disable import/prefer-default-export */
export const weekdays = {
  MONDAY: i18nMark('Mon'),
  TUESDAY: i18nMark('Tue'),
  WEDNESDAY: i18nMark('Wed'),
  THURSDAY: i18nMark('Thu'),
  FRIDAY: i18nMark('Fri'),
  SATURDAY: i18nMark('Sat'),
  SUNDAY: i18nMark('Sun'),
};



// WEBPACK FOOTER //
// ./src/compositions/TechAdmin/DealerDetails/RotationSchedulePanel/AfterHoursInfoPopup/constants.js